'use es6';

import { reduce } from '../../lib/async';
import { configure as created } from './created';
import { configure as dealprogress } from './dealprogress';
import { configure as lifecyclestage } from './lifecyclestage';
const mutators = [created, dealprogress, lifecyclestage];
export default (config => {
  return reduce(mutators, (mutated, mutator) => mutator(mutated), config);
});